<template>
    <div class="editAddressBox">
      <div class="editArea itemStyle">
        <span><i>*</i>所在地区：</span>
        <div class="rightForm">
          <el-cascader
            size="large"
            :options="options"
              v-model="$store.state.areaCode"
            @change="addressChange">
          </el-cascader>
        </div>
      </div>
      <div class="itemStyle">
        <span><i>*</i>详细地址：</span>
        <div class="rightForm">
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入地址"
            resize="none"
            maxlength="50"
            v-model="newAddress.detail">
          </el-input>
        </div>
      </div>
      <div class="itemStyle">
        <span><i>*</i>收货人姓名：</span>
        <div class="rightForm">
          <el-input maxlength="30" v-model="newAddress.realName" placeholder="请输入内容"></el-input>
        </div>
      </div>
      <div class="itemStyle">
        <span><i>*</i>手机号码：</span>
        <div class="rightForm">
          <el-input maxlength="11" v-model="newAddress.phone" placeholder="请输入内容"></el-input>
        </div>
      </div>
      <div class="itemStyle">
        <span></span>
        <div class="rightForm">
          <el-checkbox v-model="newAddress.isDefault" :true-label="1" :false-label="0" >设置为默认收货地址</el-checkbox>
        </div>
      </div>
      <div class="dialogFooter">
        <el-button type="primary" @click="newAddressData">确 定</el-button>
        <el-button @click="cancelAdd">取 消</el-button>
      </div>
    </div>
</template>

<script>
import { regionData, CodeToText } from 'element-china-area-data'
import { mapGetters, mapMutations } from 'vuex'
export default {
  name: 'addAddress',
  props:['updateAddressDate'],
  data () {
    return {
      options: regionData,
      areaData: '',
      checkdata:false,
      address:{}
    }
  },
  computed: {
    ...mapGetters([
      'newAddress' // 新增修改收货地址
    ])
  },
  mounted(){
	  // console.log(this.updateAddressDate)
	  // console.log(123)
	  // if(!this.updateAddressDate) return
		// this.updateAddress(this.updateAddressDate)
		this.addressChange(this.$store.state.areaCode)
  },
	watch:{

	},
  methods: {
    ...mapMutations({
      seNewAddress: 'SET_NEWADDRESS', // 新增修改收货地址
      setAreacode: 'SET_AREACODE', // 新增地区编码
	  updateAddress: 'updateAddress' //
    }),
    addressChange (arr) {
      this.areaData = `${CodeToText[arr[0]]}-${CodeToText[arr[1]]}-${CodeToText[arr[2]]}`
	  console.log(this.$store.state.areaCode)
    },
    newAddressData () {
		console.log('---',this.$store.state.areaCode)
        if(this.$store.state.areaCode.length == 0){
            this.$message.error('请选择所在地区!')
            return false;
        }
        if (!this.newAddress.hasOwnProperty("detail") || this.newAddress.detail === '' ) {
          this.$message.error('请填写详细地址!')
        } else if (!this.newAddress.hasOwnProperty("realName") || this.newAddress.realName === '') {
          this.$message.error('请填写收件人姓名!')
        } else if (!this.newAddress.hasOwnProperty("phone") ||this.newAddress.phone === '') {
          this.$message.error('请填写手机号码!')
        } else {
          let reg = /^1[13456789]\d{9}$/
          if (!reg.test(this.newAddress.phone)) {
            this.$message.error('手机号格式错误')
            return
          }
          this.newAddress.receiveAdress = this.areaData
          this.$emit('hideAddDialog',this.newAddress.isDefault)
					this.areaData = ""
        }
    },
    cancelAdd () {
      this.$emit('cancelAdd')
    }
  }
}
</script>

<style lang="scss" scoped>
.editAddressBox {
  padding: 0 100px;
  .itemStyle {
    display: flex;
    margin-bottom: 20px;
    span {
      width: 100px;
      margin-right: 20px;
      text-align: right;
      padding-top: 5px;
    }
    i {
      color: red;
      margin-right: 3px;
    }
    .rightForm {
      flex: 1;
      >>> .el-cascader {
        width: 100%;
      }
      >>> .el-checkbox__label {
        font-size: 12px;
        color: #666666;
      }
    }
  }
    .dialogFooter {
      display: flex;
      justify-content: center;
      width: 100%;
      button {
        width: 120px;
      }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/orderInfo/addAddress.vue